export const MOBILE_BANNER_KEY = 'mobile-banner-dismissed';
